// Import statements
import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useParams,
  useNavigate,
  useLocation
} from 'react-router-dom';
import Onboarding from './Containers/Onboarding';
import DropdownMenu from './Components/DropdownMenu';
import OnboardingRedirect from './Components/OnboardingRedirect';
import LinkAccount from './Components/LinkAccount';
import MeRedirect from './Components/MeRedirect';
import { GoogleOAuthProvider, GoogleLogin, googleLogout } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import GoogleLoginMine from './utils/GoogleLoginMine';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Homepage from './Components/Homepage';
import SharedScreen from './Components/SharedScreen';
import Login from './Components/Login';
import Footer from './Components/Footer';
import AppleCallback from './Components/AppleCallback';
import { setupTokenRefresh, getStoredToken, isTokenExpired, getAuthHeader } from './utils/tokenManager';
import './App.css'


const NoAccess = () => (
  <div>
    <h1>No Access</h1>
    <p>This user doesn't have any devices</p>
  </div>
);

const About = () => (
  <div>
    <h1>About Page</h1>
    <p>This is a placeholder for About GoTapTip.</p>
  </div>
);

const App = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const DropdownMenu = ({ routes }) => {
    const handleOpenMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    // Check if token exists without validating expiration
    const hasToken = !!getStoredToken();

    return (
      <div>
        <IconButton onClick={handleOpenMenu}>
          <MenuIcon />
        </IconButton>
        <Menu
          id="menu-basic"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          MenuListProps={{
            'aria-labelledby': 'menu-basic',
          }}
          PaperProps={{
            style: {
              minWidth: '250px',
              backgroundColor: 'white',
              maxHeight: 'none'
            },
          }}
        >
          {routes.map((route) => (
            <MenuItem key={route} onClick={() => handleCloseMenu()}>
              {route}
            </MenuItem>
          ))}
          {hasToken && (
            <MenuItem onClick={handleLogout}>
              Logout
            </MenuItem>
          )}
          {!hasToken && (<MenuItem>
            <div className="logout-button-container">
              <GoogleLoginMine />
            </div>
          </MenuItem>)}
          <br/>
          <div className="menu-divider">
            <img src="/TIPTAPGO_LOGO.png" alt="TapTipGo" className="dropdown-logo" />
          </div>
        </Menu>
      </div>
    );
  };

  // Protected route wrapper component
  const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    
    useEffect(() => {
      console.log("ProtectedRoute")
      const checkAuth = () => {
        const token = getStoredToken();
        if (!token) {
          console.log("No token")
          setIsAuthenticated(false);
          navigate('/login');
          return;
        }

        if (isTokenExpired()) {
          // Check which token exists and remove only that one
          if (localStorage.getItem('token')) {
            localStorage.removeItem('token');
          } else if (localStorage.getItem('apple_token')) {
            localStorage.removeItem('apple_token');
            localStorage.removeItem('apple_refresh_token');
            localStorage.removeItem('apple_token_expires_at');
          }
          
          // Also clear cookies if they exist
          document.cookie = "apple_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "apple_refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie = "apple_token_expires_at=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          
          setIsAuthenticated(false);
          console.log("Token expired")
          navigate('/login');
        }
      };

      checkAuth();
      const interval = setInterval(checkAuth, 3600000); // Check every hour
      return () => clearInterval(interval);
    }, [navigate]);

    return isAuthenticated ? children : null;
  };

  const handleLogout = () => {
    googleLogout();
    // Check which token exists and remove only that one
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
    } else if (localStorage.getItem('apple_token')) {
      localStorage.removeItem('apple_token');
      localStorage.removeItem('apple_refresh_token');
      localStorage.removeItem('apple_token_expires_at');
    }
    
    // Also clear cookies if they exist
    document.cookie = "apple_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "apple_refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "apple_token_expires_at=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    
    window.location.href = '/login';
  };

  // Login route component
  const LoginRoute = () => {
    const token = getStoredToken();
    return !token ? <Login /> : <Navigate to="/" />;
  };

  useEffect(() => {
    // Setup token refresh interval
    setupTokenRefresh();
  }, []);

  return (
    <GoogleOAuthProvider clientId="359488427604-rh726ge8ludntbavtm7ttfgkldlb2vg6.apps.googleusercontent.com">
      <Router>
        <div className="app-container">
          <div className="app-header">
            <div className="nav-container">
              <nav className="left-aligned-dropdown">
                <DropdownMenu routes={[<Link to="/">My Account</Link>, <Link to="/about">About</Link>]} />
              </nav>
            </div>
            <img src="/TIPTAPGO_LOGO.png" alt="TapTipGo" className="header-title" />
          </div>
          <div className="content">
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Homepage />} />
            <Route path="/:uuid/" element={<SharedScreen />} />
            <Route path="/:uuid/me" element={<SharedScreen />} />
            <Route path="/:uuid/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/link_account" element={<LinkAccount />} />
            <Route path="/about" element={<About />} />
            <Route path="/apple-callback" element={<AppleCallback />} />
          </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
};


export default App;
